import service from '../request/index'

// 注册
export function register(data) {
	return service({
		url: '/webapi/register',
		method: "post",
		data
	})
}
// 发送验证码
export function sendSms(data) {
	return service({
		url: '/webapi/sendSms',
		method: "post",
		data
	})
}
export function uploadsendSms(data) {
	return service({
		url: '/webapi/uploadsendSms',
		method: "post",
		data
	})
}
// 登录
export function login(data) {
	return service({
		url: '/webapi/login',
		method: "post",
		data
	})
}
// 忘记密码
export function forgotPassword(data) {
	return service({
		url: '/webapi/forgotPassword',
		method: "post",
		data
	})
}
//咨询建议
export function apiconsultList(data) {
	return service({
		url: '/webapi/apiconsult',
		method: "post",
		data
	})
}
// 获取验证码图片
export function captchaImage(data) {
	return service({
		url: '/captchaImage',
		method: "get",
		data
	})
}
// 获取验证码图片
export function forgotPasswordSendSms(data) {
	return service({
		
		url: '/webapi/forgotPasswordSendSms',
		method: "post",
		data
	})
} // 轮播图
export function apiadlist(data) {
	return service({
		url: '/webapi/apiad/list',
		method: "get",
		data
	})
}
// 网站配置接口
export function apisettings(data) {
	return service({
		url: '/webapi/apisettings/1',
		method: "get",
		data
	})
}
// 新闻接口
export function dynamiclist(query) {
	return service({
		url: '/webapi/dynamic/list',
		method: "get",
		params: query
	})
} 
//新闻详情
export function dynamicDet(id) {
	return service({
		url: '/webapi/dynamic/' + id,
		method: "get",
	})
} 
//新闻详情上一条
export function previous(id) {
	return service({
		url: '/webapi/dynamic/previous/' + id,
		method: "get",
	})
} 
//新闻详情下一条
export function next(id) {
	return service({
		url: '/webapi/dynamic/next/' + id,
		method: "get",
	})
} 
// 新闻接口顶部
export function dynamiclisttop(data) {
	return service({
		url: '/webapi/dynamic/list?status=1',
		method: "get",
		data
	})
} 
// 政策法规
export function apiregulationslist(query) {
	return service({
		url: '/webapi/apiregulations/list',
		method: "get",
		params: query
	})
}


// 政策法规详情
export function apiregulationsinfo(id) {
	return service({
		url: '/webapi/apiregulations/' + id,
		method: "get",
	
	})
}
//政策法规详情上一条
export function apiregulationsprevious(id) {
	return service({
		url: '/webapi/apiregulations/previous/' + id,
		method: "get",
	})
} 
//政策法规详情下一条
export function apiregulationsnext(id) {
	return service({
		url: '/webapi/apiregulations/next/' + id,
		method: "get",
	})
} 
// 证书公布
export function apicertificatelist(query) {
	return service({
		url: '/webapi/apicertificate/list',
		method: "get",
		params: query
	})
}
//证书公布详情
export function apicertificateDet(id) {
	return service({
		url: '/webapi/apicertificate/' + id,
		method: "get",
	})
} 
//证书公布详情 上一条 下一条
// export function articlseDet(id) {
// 	return service({
// 		url: '/webapi/apicertificate/' + id,
// 		method: "get",
// 	})
// }
//证书公布详情 上一条
export function apicertificateprevious(id) {
	return service({
		url: '/webapi/apicertificate/previous/' + id,
		method: "get",
	})
}
//证书公布详情  下一条
export function apicertificatenext(id) {
	return service({
		url: '/webapi/apicertificate/next/' + id,
		method: "get",
	})
}
//关于我们
export function apiaboutList(query) {
	return service({
		url: '/webapi/apiabout/list',
		method: "get",
		params: query
	})
}
//关于我们详情
export function apiaboutID(id) {
	return service({
		url: '/webapi/apiabout/' + id,
		method: "get",
	})
}
//认证监测
export function apitestingList(query) {
	return service({
		url: '/webapi/apitesting/list',
		method: "get",
		params: query
	})
}
//认证监测详情
export function apitestingdel(id) {
	return service({
		url: '/webapi/apitesting/' + id,
		method: "get",
	})
}
//建议分类
export function dictDataList(query) {
	return service({
		url: '/webapi/dict/data/list',
		method: "get",
		params: query
	})
}
//行业列表
export function apiindustryList(query) {
	return service({
		url: '/webapi/apiindustry/list',
		method: "get",
		params: query
	})
}

//行业列表详情
export function apiindustryId(id) {
	return service({
		url: '/webapi/apiindustry/' + id,
		method: "get",
	})
}

//个人信息详情
export function userinfoInfo(query) {
	return service({
		url: '/webapi/apiuser/userinfo',
		method: "get",
		params: query
	})
}

//修改企业信息
export function apiuserEant(data) {
	return service({
		url: '/webapi/apiuser',
		method: "PUT",
		data
	})
}

//修改企业信息
export function mycertificateList(query) {
	return service({
		url: '/webapi/apicertificate/mycertificate',
		method: "get",
		params: query
	})
}

export function apifigurationList(query) {
	return service({
		url: '/webapi/apiindicatorconfiguration/list',
		method: "get",
		params: query
	})
}
//提交评价申请
export function applyforList(data) {
	return service({
		url: '/webapi/apiexamine/applyfor',
		method: "post",
		data
	})
}
//修改提交评价申请
export function editapplyforList(data) {
	return service({
		url: '/webapi/apiexamine',
		method: "put",
		data
	})
}
//友链
export function apilinkList(query) {
	return service({
		url: '/webapi/apilink/list',
		method: "get",
		params: query
	})
}
//修改密码
export function ChangePassword(data) {
	return service({
		url: '/webapi/apiuser/ChangePassword',
		method: "put",
		data
	})
}
//信息暂存
export function saveTemporary(data) {
	return service({
		url: '/webapi/apiexamine/save',
		method: "post",
		data
	})
}